<template>
  <chip
    :payload="payload"
    disabled
  />
</template>

<script>
import Chip from 'Support/components/chips/Chip.vue';

export default {
  name: 'DataTableChipStatusRow',
  components: {
    Chip,
  },
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      options: [],
    };
  },
  computed: {
    getValue() {
      return this.value;
    },
    payload() {
      const item = this.options.find(
        opt => opt.value === this.value,
      );
      if (item) {
        return this.prepareItem(item);
      }
      return {
        ...this.faultColors,
        label: this.value,
      };
    },
    faultColors() {
      return {
        color: '#adb5bd',
        textColor: '#e9ecef',
      };
    },
  },
  methods: {
    prepareItem(item) {
      return item;
    },
  },
};
</script>
